
























import Vue from 'vue'

export default Vue.extend({
  name: 'WaitListChange',

  props: {
    brand: {
      type: String,
      required: true,
    },
    currentWaitListBrand: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  methods: {
    handleNotifyMeClicked() {
      this.loading = true

      this.$emit('wait-list-modal-create')
    },
  },
})
